module.exports = __webpack_public_path__ + "img/skout.f508c693.png";